import { render, staticRenderFns } from "./ProductSlideContainer.vue?vue&type=template&id=c9ca4fc4&scoped=true&"
import script from "./ProductSlideContainer.vue?vue&type=script&lang=js&"
export * from "./ProductSlideContainer.vue?vue&type=script&lang=js&"
import style0 from "./ProductSlideContainer.vue?vue&type=style&index=0&id=c9ca4fc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9ca4fc4",
  null
  
)

export default component.exports